import React from "react";
import { Quote, Star } from "lucide-react";

const reviews = [
  {
    name: "Susan",
    handle: "@susan",
    img: "https://storage.googleapis.com/jobhacki-assets/reviews/susan.jpg",
    quote:
      "Cancelled three subscriptions the day I joined. The playbook directory alone was worth way more than $7.",
    color: "bg-[#FFE600]",
  },
  {
    name: "Jony",
    handle: "@jony",
    img: "https://storage.googleapis.com/jobhacki-assets/reviews/jony.jpg",
    quote:
      "Resume builder + simulator combo got me 3 onsites in 2 weeks. Never seen tools snap together like this.",
    color: "bg-[#00FF66]",
  },
  {
    name: "Clipper",
    handle: "@clipper",
    img: "https://storage.googleapis.com/jobhacki-assets/reviews/clipper.jpg",
    quote:
      "OmniCut is unfair. Made 8 shorts in one afternoon and 2 of them broke 100k views.",
    color: "bg-[#0055FF]",
    fg: "text-white",
  },
  {
    name: "Bupers",
    handle: "@bupers",
    img: "https://storage.googleapis.com/jobhacki-assets/reviews/bupers.jpg",
    quote:
      "Was 100% expecting a course. Got a working vault instead. Logged in and shipped my first playbook the same hour.",
    color: "bg-[#FF3B30]",
    fg: "text-white",
  },
  {
    name: "Mikiauto",
    handle: "@mikiauto",
    img: "https://storage.googleapis.com/jobhacki-assets/reviews/mikiauto.jpg",
    quote:
      "Live job board is the first one that does not recycle the same 4 reposts. Everything is real.",
    color: "bg-[#FDFBF7]",
  },
  {
    name: "Theunknown",
    handle: "@theunknown",
    img: "https://storage.googleapis.com/jobhacki-assets/reviews/theunknown.jpg",
    quote:
      "Simulator is meaner than my actual interviews. After two weeks I was not nervous anymore. Signed the offer.",
    color: "bg-[#FF00FF]",
    fg: "text-white",
  },
];

export default function Reviews() {
  return (
    <section
      id="tm"
      data-testid="reviews"
      className="border-b-4 border-[#0a0a0a] bg-[#FDFBF7]"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12 reveal">
          <div>
            <div className="font-accent text-sm bg-[#0a0a0a] text-[#FFE600] inline-block px-3 py-1 mb-4">
              RECEIPTS
            </div>
            <h2 className="font-display text-5xl md:text-6xl lg:text-7xl">
              They stopped
              <br />
              <span className="bg-[#FFE600] px-2">applying.</span> Started{" "}
              <span className="bg-[#00FF66] px-2">winning.</span>
            </h2>
          </div>
          <div className="flex items-center gap-1 font-display">
            {[1, 2, 3, 4, 5].map((i) => (
              <Star key={i} size={28} fill="#FFE600" strokeWidth={2} />
            ))}
            <span className="ml-2 text-2xl">4.9</span>
            <span className="font-mono-body text-xs ml-2 text-[#0a0a0a]/60">
              / 5 · Whop verified
            </span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {reviews.map((r, i) => (
            <article
              key={r.name}
              data-testid={`review-${i}`}
              className={`${r.color} ${r.fg || "text-[#0a0a0a]"} border-4 border-[#0a0a0a] shadow-brutal hover-pop p-6 md:p-7 flex flex-col reveal`}
            >
              <Quote size={28} strokeWidth={2.5} className="mb-4" />
              <p className="font-mono-body text-base leading-relaxed mb-6 flex-1">
                &ldquo;{r.quote}&rdquo;
              </p>
              <div className="flex items-center gap-3 pt-4 border-t-2 border-[#0a0a0a]/40">
                <img
                  src={r.img}
                  alt={r.name}
                  className="w-12 h-12 object-cover border-2 border-[#0a0a0a]"
                  onError={(e) => {
                    e.currentTarget.style.display = "none";
                  }}
                />
                <div className="flex-1 min-w-0">
                  <div className="font-display text-base leading-tight">
                    {r.name}
                  </div>
                  <div className="font-mono-body text-[11px] opacity-75">
                    {r.handle}
                  </div>
                </div>
                <div className="flex items-center gap-0.5">
                  {[1, 2, 3, 4, 5].map((j) => (
                    <Star key={j} size={11} fill="currentColor" strokeWidth={0} />
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
